import { Fetcher } from "@connect/fetcher";
import { router } from "../router";

export const AdminFetcher = new Fetcher('/api', {})

const goodStatuses = [200,201]
const freeMethods = ['/superadmin/login', '/superadmin/check']

AdminFetcher.setMiddleware({}, (inp) => {
  if(!goodStatuses.includes(inp.response.status)) {
    if([401, 403].includes(inp.response.status) && !freeMethods.includes(inp.path)) {
      alert("Что-то пошло не так, недостаточно прав или истекла сессия")
      router.push({ name: "admin-login" })
    }
    throw {
      data: inp.data,
      status: inp.response.status,
    }
  } else {
    return inp.data
  }
})
